// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.PNG = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.PNG = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var PNG = _exports.PNG = function PNG(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.927 8.49609V16.9268C16.927 17.4779 16.7081 18.0065 16.3184 18.3961C15.9287 18.7858 15.4002 19.0048 14.8491 19.0048H5.15214C4.60104 19.0048 4.07251 18.7858 3.68283 18.3961C3.29314 18.0065 3.07422 17.4779 3.07422 16.9268V3.07402C3.07422 2.52292 3.29314 1.99439 3.68283 1.6047C4.07251 1.21502 4.60104 0.996094 5.15214 0.996094H9.42703C9.79431 0.996149 10.1465 1.14205 10.4063 1.40172L16.5214 7.51687C16.7811 7.7766 16.927 8.12882 16.927 8.49609Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 1V6.19481C10 6.5622 10.1459 6.91456 10.4057 7.17435C10.6655 7.43414 11.0179 7.58009 11.3853 7.58009H16.5801",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5 15.6861H5.87891V14.5568H6.4755C7.30824 14.5568 7.82848 14.0632 7.82848 13.3086C7.82848 12.5611 7.31889 12.0497 6.50213 12.0497H5V15.6861ZM5.87891 13.8643V12.7582H6.31214C6.70632 12.7582 6.91761 12.9712 6.91761 13.3086C6.91761 13.6442 6.70632 13.8643 6.31214 13.8643H5.87891Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.3565 12.0497H10.4794V14.1449H10.4492L9.01811 12.0497H8.26172V15.6861H9.14062V13.5874H9.16371L10.6108 15.6861H11.3565V12.0497Z",
      fill: "currentColor"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M14.2955 13.2376H15.1851C15.0963 12.5131 14.45 12 13.6084 12C12.6372 12 11.8701 12.6836 11.8701 13.8732C11.8701 15.0238 12.5768 15.7358 13.6191 15.7358C14.5548 15.7358 15.2242 15.1552 15.2242 14.1786V13.6974H13.6563V14.3384H14.3772C14.3683 14.7219 14.102 14.9652 13.6262 14.9652C13.0811 14.9652 12.7668 14.5621 12.7668 13.8626C12.7668 13.1683 13.0988 12.7706 13.6262 12.7706C13.9777 12.7706 14.2174 12.9428 14.2955 13.2376Z",
      fill: "currentColor"
    }));
  };
});
